module.exports = __webpack_public_path__ + "static/chart-dosing2-a9a55f2f0a393c6d7a18266861f39363.png";